////
/// ============================================================================
/// COMPONENT / Load More Items
/// ============================================================================
///
/// @group components
////

export default () => {
    document.querySelectorAll(".js-loadmore-items").forEach(episodes => {
        let items = episodes.querySelectorAll(".js-loadmore-items-item");
        let loadMore = episodes.querySelector(".js-loadmore-items-btn");
        let initialVisibleItems = episodes.dataset.initial || 4;
        let showMoreItems = episodes.dataset.showMore || 10;
        let hiddenClass = "sr-only";

        function checkLoaded() {
            if (episodes.querySelectorAll("." + hiddenClass).length === 0) {
                episodes.classList.add("is-loaded");
            }
        }

        items.forEach((item, index) => {
            if (index > initialVisibleItems - 1) {
                item.classList.add(hiddenClass);
            }
        });

        loadMore.addEventListener("click", (event) => {
            event.preventDefault();

            episodes.querySelectorAll("." + hiddenClass).forEach((item, index) => {
                if (index < showMoreItems) {
                    item.classList.remove(hiddenClass);
                }
            });

            checkLoaded();
        });

        checkLoaded();
    });
};
